/*!
 @overseas/monitor-sdk
 version 0.0.8-10 
*/
"use strict";
var SonarBrowser = (() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // node_modules/.pnpm/blueimp-md5@2.19.0/node_modules/blueimp-md5/js/md5.js
  var require_md5 = __commonJS({
    "node_modules/.pnpm/blueimp-md5@2.19.0/node_modules/blueimp-md5/js/md5.js"(exports, module) {
      "use strict";
      (function($) {
        "use strict";
        function safeAdd(x2, y2) {
          var lsw = (x2 & 65535) + (y2 & 65535);
          var msw = (x2 >> 16) + (y2 >> 16) + (lsw >> 16);
          return msw << 16 | lsw & 65535;
        }
        function bitRotateLeft(num, cnt) {
          return num << cnt | num >>> 32 - cnt;
        }
        function md5cmn(q2, a2, b2, x2, s2, t) {
          return safeAdd(bitRotateLeft(safeAdd(safeAdd(a2, q2), safeAdd(x2, t)), s2), b2);
        }
        function md5ff(a2, b2, c2, d2, x2, s2, t) {
          return md5cmn(b2 & c2 | ~b2 & d2, a2, b2, x2, s2, t);
        }
        function md5gg(a2, b2, c2, d2, x2, s2, t) {
          return md5cmn(b2 & d2 | c2 & ~d2, a2, b2, x2, s2, t);
        }
        function md5hh(a2, b2, c2, d2, x2, s2, t) {
          return md5cmn(b2 ^ c2 ^ d2, a2, b2, x2, s2, t);
        }
        function md5ii(a2, b2, c2, d2, x2, s2, t) {
          return md5cmn(c2 ^ (b2 | ~d2), a2, b2, x2, s2, t);
        }
        function binlMD5(x2, len) {
          x2[len >> 5] |= 128 << len % 32;
          x2[(len + 64 >>> 9 << 4) + 14] = len;
          var i;
          var olda;
          var oldb;
          var oldc;
          var oldd;
          var a2 = 1732584193;
          var b2 = -271733879;
          var c2 = -1732584194;
          var d2 = 271733878;
          for (i = 0; i < x2.length; i += 16) {
            olda = a2;
            oldb = b2;
            oldc = c2;
            oldd = d2;
            a2 = md5ff(a2, b2, c2, d2, x2[i], 7, -680876936);
            d2 = md5ff(d2, a2, b2, c2, x2[i + 1], 12, -389564586);
            c2 = md5ff(c2, d2, a2, b2, x2[i + 2], 17, 606105819);
            b2 = md5ff(b2, c2, d2, a2, x2[i + 3], 22, -1044525330);
            a2 = md5ff(a2, b2, c2, d2, x2[i + 4], 7, -176418897);
            d2 = md5ff(d2, a2, b2, c2, x2[i + 5], 12, 1200080426);
            c2 = md5ff(c2, d2, a2, b2, x2[i + 6], 17, -1473231341);
            b2 = md5ff(b2, c2, d2, a2, x2[i + 7], 22, -45705983);
            a2 = md5ff(a2, b2, c2, d2, x2[i + 8], 7, 1770035416);
            d2 = md5ff(d2, a2, b2, c2, x2[i + 9], 12, -1958414417);
            c2 = md5ff(c2, d2, a2, b2, x2[i + 10], 17, -42063);
            b2 = md5ff(b2, c2, d2, a2, x2[i + 11], 22, -1990404162);
            a2 = md5ff(a2, b2, c2, d2, x2[i + 12], 7, 1804603682);
            d2 = md5ff(d2, a2, b2, c2, x2[i + 13], 12, -40341101);
            c2 = md5ff(c2, d2, a2, b2, x2[i + 14], 17, -1502002290);
            b2 = md5ff(b2, c2, d2, a2, x2[i + 15], 22, 1236535329);
            a2 = md5gg(a2, b2, c2, d2, x2[i + 1], 5, -165796510);
            d2 = md5gg(d2, a2, b2, c2, x2[i + 6], 9, -1069501632);
            c2 = md5gg(c2, d2, a2, b2, x2[i + 11], 14, 643717713);
            b2 = md5gg(b2, c2, d2, a2, x2[i], 20, -373897302);
            a2 = md5gg(a2, b2, c2, d2, x2[i + 5], 5, -701558691);
            d2 = md5gg(d2, a2, b2, c2, x2[i + 10], 9, 38016083);
            c2 = md5gg(c2, d2, a2, b2, x2[i + 15], 14, -660478335);
            b2 = md5gg(b2, c2, d2, a2, x2[i + 4], 20, -405537848);
            a2 = md5gg(a2, b2, c2, d2, x2[i + 9], 5, 568446438);
            d2 = md5gg(d2, a2, b2, c2, x2[i + 14], 9, -1019803690);
            c2 = md5gg(c2, d2, a2, b2, x2[i + 3], 14, -187363961);
            b2 = md5gg(b2, c2, d2, a2, x2[i + 8], 20, 1163531501);
            a2 = md5gg(a2, b2, c2, d2, x2[i + 13], 5, -1444681467);
            d2 = md5gg(d2, a2, b2, c2, x2[i + 2], 9, -51403784);
            c2 = md5gg(c2, d2, a2, b2, x2[i + 7], 14, 1735328473);
            b2 = md5gg(b2, c2, d2, a2, x2[i + 12], 20, -1926607734);
            a2 = md5hh(a2, b2, c2, d2, x2[i + 5], 4, -378558);
            d2 = md5hh(d2, a2, b2, c2, x2[i + 8], 11, -2022574463);
            c2 = md5hh(c2, d2, a2, b2, x2[i + 11], 16, 1839030562);
            b2 = md5hh(b2, c2, d2, a2, x2[i + 14], 23, -35309556);
            a2 = md5hh(a2, b2, c2, d2, x2[i + 1], 4, -1530992060);
            d2 = md5hh(d2, a2, b2, c2, x2[i + 4], 11, 1272893353);
            c2 = md5hh(c2, d2, a2, b2, x2[i + 7], 16, -155497632);
            b2 = md5hh(b2, c2, d2, a2, x2[i + 10], 23, -1094730640);
            a2 = md5hh(a2, b2, c2, d2, x2[i + 13], 4, 681279174);
            d2 = md5hh(d2, a2, b2, c2, x2[i], 11, -358537222);
            c2 = md5hh(c2, d2, a2, b2, x2[i + 3], 16, -722521979);
            b2 = md5hh(b2, c2, d2, a2, x2[i + 6], 23, 76029189);
            a2 = md5hh(a2, b2, c2, d2, x2[i + 9], 4, -640364487);
            d2 = md5hh(d2, a2, b2, c2, x2[i + 12], 11, -421815835);
            c2 = md5hh(c2, d2, a2, b2, x2[i + 15], 16, 530742520);
            b2 = md5hh(b2, c2, d2, a2, x2[i + 2], 23, -995338651);
            a2 = md5ii(a2, b2, c2, d2, x2[i], 6, -198630844);
            d2 = md5ii(d2, a2, b2, c2, x2[i + 7], 10, 1126891415);
            c2 = md5ii(c2, d2, a2, b2, x2[i + 14], 15, -1416354905);
            b2 = md5ii(b2, c2, d2, a2, x2[i + 5], 21, -57434055);
            a2 = md5ii(a2, b2, c2, d2, x2[i + 12], 6, 1700485571);
            d2 = md5ii(d2, a2, b2, c2, x2[i + 3], 10, -1894986606);
            c2 = md5ii(c2, d2, a2, b2, x2[i + 10], 15, -1051523);
            b2 = md5ii(b2, c2, d2, a2, x2[i + 1], 21, -2054922799);
            a2 = md5ii(a2, b2, c2, d2, x2[i + 8], 6, 1873313359);
            d2 = md5ii(d2, a2, b2, c2, x2[i + 15], 10, -30611744);
            c2 = md5ii(c2, d2, a2, b2, x2[i + 6], 15, -1560198380);
            b2 = md5ii(b2, c2, d2, a2, x2[i + 13], 21, 1309151649);
            a2 = md5ii(a2, b2, c2, d2, x2[i + 4], 6, -145523070);
            d2 = md5ii(d2, a2, b2, c2, x2[i + 11], 10, -1120210379);
            c2 = md5ii(c2, d2, a2, b2, x2[i + 2], 15, 718787259);
            b2 = md5ii(b2, c2, d2, a2, x2[i + 9], 21, -343485551);
            a2 = safeAdd(a2, olda);
            b2 = safeAdd(b2, oldb);
            c2 = safeAdd(c2, oldc);
            d2 = safeAdd(d2, oldd);
          }
          return [a2, b2, c2, d2];
        }
        function binl2rstr(input) {
          var i;
          var output = "";
          var length32 = input.length * 32;
          for (i = 0; i < length32; i += 8) {
            output += String.fromCharCode(input[i >> 5] >>> i % 32 & 255);
          }
          return output;
        }
        function rstr2binl(input) {
          var i;
          var output = [];
          output[(input.length >> 2) - 1] = void 0;
          for (i = 0; i < output.length; i += 1) {
            output[i] = 0;
          }
          var length8 = input.length * 8;
          for (i = 0; i < length8; i += 8) {
            output[i >> 5] |= (input.charCodeAt(i / 8) & 255) << i % 32;
          }
          return output;
        }
        function rstrMD5(s2) {
          return binl2rstr(binlMD5(rstr2binl(s2), s2.length * 8));
        }
        function rstrHMACMD5(key, data) {
          var i;
          var bkey = rstr2binl(key);
          var ipad = [];
          var opad = [];
          var hash;
          ipad[15] = opad[15] = void 0;
          if (bkey.length > 16) {
            bkey = binlMD5(bkey, key.length * 8);
          }
          for (i = 0; i < 16; i += 1) {
            ipad[i] = bkey[i] ^ 909522486;
            opad[i] = bkey[i] ^ 1549556828;
          }
          hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
          return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
        }
        function rstr2hex(input) {
          var hexTab = "0123456789abcdef";
          var output = "";
          var x2;
          var i;
          for (i = 0; i < input.length; i += 1) {
            x2 = input.charCodeAt(i);
            output += hexTab.charAt(x2 >>> 4 & 15) + hexTab.charAt(x2 & 15);
          }
          return output;
        }
        function str2rstrUTF8(input) {
          return unescape(encodeURIComponent(input));
        }
        function rawMD5(s2) {
          return rstrMD5(str2rstrUTF8(s2));
        }
        function hexMD5(s2) {
          return rstr2hex(rawMD5(s2));
        }
        function rawHMACMD5(k2, d2) {
          return rstrHMACMD5(str2rstrUTF8(k2), str2rstrUTF8(d2));
        }
        function hexHMACMD5(k2, d2) {
          return rstr2hex(rawHMACMD5(k2, d2));
        }
        function md52(string, key, raw) {
          if (!key) {
            if (!raw) {
              return hexMD5(string);
            }
            return rawMD5(string);
          }
          if (!raw) {
            return hexHMACMD5(key, string);
          }
          return rawHMACMD5(key, string);
        }
        if (typeof define === "function" && define.amd) {
          define(function() {
            return md52;
          });
        } else if (typeof module === "object" && module.exports) {
          module.exports = md52;
        } else {
          $.md5 = md52;
        }
      })(exports);
    }
  });

  // src/browser.ts
  var browser_exports = {};
  __export(browser_exports, {
    init: () => init,
    use: () => use
  });

  // src/libs/span.ts
  var Span = class {
    constructor({ traceId, spanId, action, parentSpanId, sdk: sdk2 }) {
      this.traceId = traceId;
      this.spanId = spanId;
      this.action = action;
      this.parentSpanId = parentSpanId;
      this.startTime = Date.now();
      this.sdk = sdk2;
    }
    addStaus(status) {
      this.status = status;
      this.sdk.report(this.getData());
    }
    // 结束 span
    end(status) {
      this.endTime = Date.now();
      this.status = status;
      this.sdk.report(this.getData());
    }
    // 获取 span 数据
    getData() {
      const data = {
        traceId: this.traceId,
        spanId: this.spanId,
        pspanId: this.parentSpanId,
        action: this.action,
        timestamp: Date.now(),
        elapsed: this.endTime ? this.endTime - this.startTime : void 0,
        status: this.status
      };
      return data;
    }
  };

  // src/utils/tool.ts
  var get = (obj, path, defat) => {
    if (obj == null) return defat;
    const keys = JSON.stringify(path).match(/[^.,\s[\]'"]+/g);
    if (!keys) return defat;
    let ret;
    for (let i = 0, j2 = keys.length; i < j2; i++) {
      ret = obj[keys[i]];
      if (ret == null) return defat;
      obj = ret;
    }
    return ret;
  };
  var set = (obj, path, value) => {
    if (obj == null || path == null) return obj;
    const keys = JSON.stringify(path).match(/[^.,\s[\]'"]+/g);
    if (!keys) return obj;
    let _obj = obj;
    for (let i = 0, j2 = keys.length; i < j2; i++) {
      const temp = _obj[keys[i]];
      if (temp == null) {
        if (i + 1 === j2) {
          _obj[keys[i]] = value;
          break;
        }
        _obj[keys[i]] = /\d+/.test(keys[i]) ? [] : {};
      } else if (i + 1 === j2) {
        _obj[keys[i]] = value;
      }
      _obj = _obj[keys[i]];
    }
    return obj;
  };
  function generateRandomID(length = 16) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      result += characters[randomIndex];
    }
    return result;
  }
  var isEmpty = (val) => val == null || !(Object.keys(val) || val).length;
  var formatDecimal = (num, decimal) => {
    if (!isFinite(num) || isNaN(num)) {
      return num;
    }
    if (!Number.isInteger(decimal) || decimal < 0) {
      return num;
    }
    return parseFloat(num.toFixed(decimal));
  };
  function isIPAddress(hostname) {
    const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    const ipv6Pattern = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
    return ipv4Pattern.test(hostname) || ipv6Pattern.test(hostname);
  }

  // src/libs/monitor-sdk.ts
  var MonitorSdk2 = class {
    constructor({ enable, debug, app, endpoint, deviceId, version, platform, bufferSize = 10, flushInterval = 1e3 }) {
      this.plugins = [];
      this.buffer = [];
      this.flushTimer = null;
      this.spanId = "";
      this.user = {};
      this.location = {};
      this.version = "";
      this.traceId = "";
      this.enable = true;
      this.debug = false;
      this.endpoint = endpoint;
      this.bufferSize = bufferSize;
      this.flushInterval = flushInterval;
      this.createTime = Date.now();
      this.app = app;
      this.deviceId = deviceId;
      this.platform = platform;
      this.version = version;
      this.enable = enable;
      this.debug = debug || false;
    }
    setTraceId(id) {
      this.traceId = id;
    }
    setSpanId(spanId) {
      this.spanId = spanId;
    }
    getEndpoint() {
      return this.endpoint;
    }
    // 注册插件
    use(plugin) {
      plugin.init(this);
      this.plugins.push(plugin);
    }
    /**
     * 添加数据到缓冲区
     * @param data 上报的数据
     * @param samplingRate 采样率
     * @param immediate 是否立即发送
     */
    report(data, samplingRate = 1, immediate = false) {
      if (!data) return;
      if (!data.timestamp) data.timestamp = Date.now();
      if (this.shouldSample(samplingRate) === false) {
        console.log("Data not sent due to sampling.");
        return;
      }
      this.buffer.push(data);
      if (immediate || this.buffer.length >= this.bufferSize) {
        this.flush();
      }
    }
    shouldSample(samplingRate) {
      return Math.random() < samplingRate;
    }
    setUser(data) {
      this.user = data;
    }
    setLocation(data) {
      this.location = data;
    }
    // 手动刷新缓冲区，将数据发送到服务器
    flush() {
      if (this.buffer.length === 0) return;
      const baseInfo = this.plugins.reduce((s2, plugin) => {
        return {
          ...s2,
          ...plugin.addBaseInfo?.()
        };
      }, {});
      const dataToSend = this.buffer.map((data) => {
        return {
          ...baseInfo,
          ...data,
          traceId: this.traceId,
          spanId: this.spanId,
          app: this.app,
          version: this.version,
          user: this.user,
          location: this.location,
          platform: this.platform,
          sdk: "0.0.8-10"
        };
      });
      this.buffer = [];
      if (this.enable) {
        this.send(dataToSend);
      }
      if (this.debug || !this.enable) {
        console.log("monitor dataToSend:", dataToSend);
      }
    }
    send(_dataToSend) {
      console.error("The send method is not implemented");
    }
    // 启动定时器以定期刷新缓冲区
    startFlushTimer() {
      this.flushTimer = setInterval(() => this.flush(), this.flushInterval);
    }
    // 停止定时器
    stopFlushTimer() {
      if (this.flushTimer) {
        clearInterval(this.flushTimer);
        this.flushTimer = null;
      }
    }
    // 创建一个新的 span
    createSpan(action, traceId, parentSpanId) {
      const spanId = generateRandomID(16);
      if (!parentSpanId) parentSpanId = this.spanId;
      const span = new Span({
        traceId,
        spanId,
        action,
        parentSpanId,
        sdk: this
      });
      return span;
    }
  };

  // src/utils/fingerprinting.ts
  function getScreenResolution() {
    return screen.height > screen.width ? [screen.height, screen.width] : [screen.width, screen.height];
  }
  function isCanvasSupported() {
    if (typeof document !== "undefined") {
      try {
        const elem = document.createElement("canvas");
        return !!(elem.getContext && elem.getContext("2d"));
      } catch (error) {
        return false;
      }
    }
    return false;
  }
  function createCanvasFingerprinting() {
    if (typeof document !== "undefined") {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        return "";
      } else {
        const txt = "HopeGoo,com <canvas> 0.1";
        ctx.textBaseline = "bottom";
        ctx.font = "14px 'Arial'";
        ctx.textBaseline = "alphabetic";
        ctx.fillStyle = "#f20";
        ctx.fillRect(139, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText(txt, 2, 15);
        ctx.fillStyle = "rgba(102, 203, 0, 0.7)";
        ctx.fillText(txt, 4, 17);
        return canvas.toDataURL();
      }
    }
    return "";
  }
  function javaHashCode(string, K) {
    let char;
    let hash = 16;
    if (string.length === 0) {
      return hash;
    }
    for (let i = 0; i < string.length; i++) {
      char = string.charCodeAt(i);
      hash = K * ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return Math.abs(hash).toString(16);
  }
  function createFingerprint() {
    if (typeof window === "undefined") return "";
    const keys = [];
    keys.push(navigator.userAgent);
    keys.push(navigator.language);
    keys.push("" + screen.colorDepth);
    keys.push(getScreenResolution().join("x"));
    keys.push("" + (/* @__PURE__ */ new Date()).getTimezoneOffset());
    keys.push(navigator.platform);
    if (isCanvasSupported()) {
      keys.push(createCanvasFingerprinting());
    }
    return javaHashCode(keys.join("###"), 31);
  }

  // src/plugins/browser-base.ts
  var BrowserBase = class {
    constructor() {
      this.endpoint = "";
      this.sysInfo = null;
    }
    init(sdk2) {
      this.sdk = sdk2;
      sdk2.send = this.send.bind(this);
      sdk2.setTraceId(this.getTraceId());
      sdk2.setSpanId(this.getSpanId());
      sdk2.startFlushTimer();
      document.addEventListener("visibilitychange", function logData() {
        if (document.visibilityState === "hidden") {
          sdk2.flush();
        }
      });
      if (typeof fetch === "function") {
        fetch("https://static.hopegoo.com/aux/getip", {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json"
          }
        }).then((response) => {
          return response.json();
        }).then((data) => {
          const countryCode = get(data, "country.iso_code");
          if (countryCode) {
            set(sdk2, "location.district", countryCode);
          }
        });
        fetch("https://static.hopegoo.com/aux/getua", {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json"
          }
        }).then((response) => {
          return response.json();
        }).then((data) => {
          this.sysInfo = data;
        });
      }
    }
    send(dataToSend) {
      const endpoint = this.sdk?.getEndpoint();
      if (!endpoint) return;
      const xhr = new XMLHttpRequest();
      xhr.open("POST", endpoint, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status >= 200 && xhr.status < 300) {
          } else {
            console.error("Failed to report monitoring data:", xhr.statusText);
          }
        }
      };
      xhr.onerror = () => {
        console.error("Error reporting monitoring data:", xhr.statusText);
      };
      xhr.send(JSON.stringify({ data: dataToSend }));
    }
    getSysInfo() {
      if (this.sysInfo) return this.sysInfo;
      const { osName, osVersion } = this.getOSInfo();
      const { browserName, fullVersion } = this.getBrowserInfo();
      return {
        os: {
          name: osName,
          version: osVersion
        },
        browser: {
          name: browserName,
          version: fullVersion
        }
      };
    }
    addBaseInfo() {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
      let deviceId = this.sdk?.deviceId || localStorage.getItem("__CLIENT_INFO_DEVICE_ID__") || "";
      if (!deviceId) {
        deviceId = String(createFingerprint());
        if (deviceId) localStorage.setItem("__CLIENT_INFO_DEVICE_ID__", deviceId);
      }
      const page = window.location.href.split("?")[0];
      if (this.sdk && deviceId) {
        set(this.sdk, "user.deviceId", deviceId);
      }
      const { browser, os } = this.getSysInfo();
      const sys = `${os.name}/${os.version}, ${browser.name}/${browser.version}`;
      return {
        network: connection.effectiveType,
        page: encodeURI(page),
        sys
      };
    }
    getOSInfo() {
      const userAgent = navigator.userAgent;
      let osName = "Unknown OS";
      let osVersion = "Unknown Version";
      if (userAgent.indexOf("Win") !== -1) {
        osName = "Windows";
        const ntVersionMatch = userAgent.match(/Windows NT (\d+\.\d+)/);
        if (ntVersionMatch) {
          osVersion = "NT" + ntVersionMatch[1];
        }
      } else if (userAgent.indexOf("Mac") !== -1 && userAgent.indexOf("iPhone") === -1 && userAgent.indexOf("iPad") === -1 && userAgent.indexOf("iPod") === -1) {
        osName = "MacOs";
        osVersion = userAgent.substring(userAgent.indexOf("Mac OS X") + 9).split(")")[0].replace(/_/g, ".");
      } else if (userAgent.indexOf("iPhone") !== -1 || userAgent.indexOf("iPad") !== -1 || userAgent.indexOf("iPod") !== -1) {
        osName = "IOS";
        const iosVersionMatch = userAgent.match(/OS (\d+_\d+(_\d+)?)/);
        if (iosVersionMatch) {
          osVersion = iosVersionMatch[1].replace(/_/g, ".");
        }
      } else if (userAgent.indexOf("X11") !== -1) {
        osName = "UNIX";
      } else if (userAgent.indexOf("Linux") !== -1) {
        osName = "Linux";
        if (userAgent.indexOf("Android") !== -1) {
          osName = "Android";
          osVersion = userAgent.substring(userAgent.indexOf("Android") + 8).split(";")[0];
        }
      }
      return { osName, osVersion };
    }
    getBrowserInfo() {
      const userAgent = navigator.userAgent;
      let browserName = "Unknown";
      let fullVersion = "Unknown";
      if (userAgent.indexOf("Chrome") !== -1) {
        browserName = "Chrome";
        fullVersion = userAgent.substring(userAgent.indexOf("Chrome") + 7);
        fullVersion = fullVersion.split(" ")[0];
      } else if (userAgent.indexOf("Firefox") !== -1) {
        browserName = "Firefox";
        fullVersion = userAgent.substring(userAgent.indexOf("Firefox") + 8);
      } else if (userAgent.indexOf("Safari") !== -1 && userAgent.indexOf("Chrome") === -1) {
        browserName = "Safari";
        fullVersion = userAgent.substring(userAgent.indexOf("Version") + 8);
        fullVersion = fullVersion.split(" ")[0];
      } else if (userAgent.indexOf("MSIE") !== -1 || !!document.documentMode) {
        browserName = "Internet Explorer";
        fullVersion = userAgent.substring(userAgent.indexOf("MSIE") + 5);
        fullVersion = fullVersion.split(";")[0];
      }
      return { browserName, fullVersion };
    }
    getTraceId() {
      const sessionTraceId = sessionStorage.getItem("__CLIENT_INFO_TRACE_ID__");
      if (sessionTraceId) return sessionTraceId;
      const traceId = generateRandomID(32);
      sessionStorage.setItem("__CLIENT_INFO_TRACE_ID__", traceId);
      return traceId;
    }
    getSpanId() {
      const spanId = generateRandomID(16);
      return spanId;
    }
  };

  // src/utils/parseErrorStk.ts
  var FULL_MATCH = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
  var parseStackLine = (line) => {
    const lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) return {};
    const filename = lineMatch[2];
    const functionName = lineMatch[1] || "";
    const lineno = parseInt(lineMatch[3], 10) || void 0;
    const colno = parseInt(lineMatch[4], 10) || void 0;
    return {
      file: filename,
      fn: functionName,
      line: lineno,
      col: colno
    };
  };
  var parseStackFrames = (error, limit = 10) => {
    if (!error) return [];
    const stack = error.stack;
    if (!stack) return [];
    const frames = [];
    for (const line of stack.split("\n").slice(1)) {
      const frame = parseStackLine(line);
      if (frame) {
        frames.push(frame);
      }
    }
    return frames.slice(0, limit);
  };

  // src/plugins/browser-error.ts
  var import_blueimp_md5 = __toESM(require_md5());
  var BrowserBase2 = class {
    init(sdk2) {
      if (typeof window === "undefined") return;
      const ignoreError = [];
      const stkLimit = 10;
      const errorCaches = [];
      const originError = window.onerror;
      window.onerror = function(...args) {
        if (args && args.length > 0 && ignoreError.includes(args[0])) {
          console.warn("window.onerror", args);
          return;
        }
        if (originError) {
          originError(...args);
        }
        const [msg, url, line, column, error] = args;
        if (!msg && !url && !line && !column && !error) {
          return;
        }
        const frames = parseStackFrames(error, stkLimit);
        const errorUid = (0, import_blueimp_md5.default)(JSON.stringify(error?.stack || error));
        if (errorCaches.includes(errorUid)) {
          return;
        }
        errorCaches.push(errorUid);
        setTimeout(() => errorCaches.splice(errorCaches.indexOf(errorUid), 1), 25);
        sdk2.report({
          module: "error",
          action: "js_error",
          target: [encodeURI(url || ""), line, column].join(":"),
          status: errorUid,
          logs: {
            msg,
            stack: frames
          }
        });
      };
      window.addEventListener(
        "error",
        function(event) {
          const target = event.target || event.srcElement;
          const isScript = target instanceof HTMLScriptElement;
          const isLink = target instanceof HTMLLinkElement;
          const isImg = target instanceof HTMLImageElement;
          const isElementTarget = isScript || isLink || isImg;
          if (!isElementTarget) return false;
          const url = target.src || target.href;
          const type = isScript ? "script" : isLink ? "link" : isImg ? "img" : "other";
          const errorUid = (0, import_blueimp_md5.default)(JSON.stringify({ url }));
          sdk2.report({
            module: "error",
            action: "resource_error",
            target: url,
            status: errorUid,
            logs: { url, type }
          });
        },
        true
      );
      const originUnHandleRejection = window.onunhandledrejection;
      window.onunhandledrejection = function(error) {
        if (originUnHandleRejection) {
          originUnHandleRejection.call(window, error);
        }
        const reason = error.reason;
        let msg = "";
        if (typeof reason === "string") {
          msg = reason;
        } else if (typeof reason === "object" && reason.stack) {
          msg = reason.stack;
        }
        const frames = parseStackFrames(reason, 10);
        const errorUid = (0, import_blueimp_md5.default)(JSON.stringify(frames));
        const targetIndex = reason?.__monitor_stk_count__ || 0;
        const frame = frames[targetIndex];
        const target = frame ? `${frame.file}:${frame.line}:${frame.col}` : msg;
        sdk2.report({
          module: "error",
          action: "promise_error",
          target,
          status: errorUid,
          logs: {
            msg,
            stack: frames
          }
        });
      };
    }
  };

  // node_modules/.pnpm/web-vitals@4.2.4/node_modules/web-vitals/dist/web-vitals.js
  var e;
  var o = -1;
  var a = function(e2) {
    addEventListener("pageshow", function(n) {
      n.persisted && (o = n.timeStamp, e2(n));
    }, true);
  };
  var c = function() {
    var e2 = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
    if (e2 && e2.responseStart > 0 && e2.responseStart < performance.now()) return e2;
  };
  var u = function() {
    var e2 = c();
    return e2 && e2.activationStart || 0;
  };
  var f = function(e2, n) {
    var t = c(), r = "navigate";
    o >= 0 ? r = "back-forward-cache" : t && (document.prerendering || u() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : t.type && (r = t.type.replace(/_/g, "-")));
    return { name: e2, value: void 0 === n ? -1 : n, rating: "good", delta: 0, entries: [], id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: r };
  };
  var s = function(e2, n, t) {
    try {
      if (PerformanceObserver.supportedEntryTypes.includes(e2)) {
        var r = new PerformanceObserver(function(e3) {
          Promise.resolve().then(function() {
            n(e3.getEntries());
          });
        });
        return r.observe(Object.assign({ type: e2, buffered: true }, t || {})), r;
      }
    } catch (e3) {
    }
  };
  var d = function(e2, n, t, r) {
    var i, o2;
    return function(a2) {
      n.value >= 0 && (a2 || r) && ((o2 = n.value - (i || 0)) || void 0 === i) && (i = n.value, n.delta = o2, n.rating = function(e3, n2) {
        return e3 > n2[1] ? "poor" : e3 > n2[0] ? "needs-improvement" : "good";
      }(n.value, t), e2(n));
    };
  };
  var l = function(e2) {
    requestAnimationFrame(function() {
      return requestAnimationFrame(function() {
        return e2();
      });
    });
  };
  var p = function(e2) {
    document.addEventListener("visibilitychange", function() {
      "hidden" === document.visibilityState && e2();
    });
  };
  var v = function(e2) {
    var n = false;
    return function() {
      n || (e2(), n = true);
    };
  };
  var m = -1;
  var h = function() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
  };
  var g = function(e2) {
    "hidden" === document.visibilityState && m > -1 && (m = "visibilitychange" === e2.type ? e2.timeStamp : 0, T());
  };
  var y = function() {
    addEventListener("visibilitychange", g, true), addEventListener("prerenderingchange", g, true);
  };
  var T = function() {
    removeEventListener("visibilitychange", g, true), removeEventListener("prerenderingchange", g, true);
  };
  var E = function() {
    return m < 0 && (m = h(), y(), a(function() {
      setTimeout(function() {
        m = h(), y();
      }, 0);
    })), { get firstHiddenTime() {
      return m;
    } };
  };
  var C = function(e2) {
    document.prerendering ? addEventListener("prerenderingchange", function() {
      return e2();
    }, true) : e2();
  };
  var b = [1800, 3e3];
  var S = function(e2, n) {
    n = n || {}, C(function() {
      var t, r = E(), i = f("FCP"), o2 = s("paint", function(e3) {
        e3.forEach(function(e4) {
          "first-contentful-paint" === e4.name && (o2.disconnect(), e4.startTime < r.firstHiddenTime && (i.value = Math.max(e4.startTime - u(), 0), i.entries.push(e4), t(true)));
        });
      });
      o2 && (t = d(e2, i, b, n.reportAllChanges), a(function(r2) {
        i = f("FCP"), t = d(e2, i, b, n.reportAllChanges), l(function() {
          i.value = performance.now() - r2.timeStamp, t(true);
        });
      }));
    });
  };
  var L = [0.1, 0.25];
  var w = function(e2, n) {
    n = n || {}, S(v(function() {
      var t, r = f("CLS", 0), i = 0, o2 = [], c2 = function(e3) {
        e3.forEach(function(e4) {
          if (!e4.hadRecentInput) {
            var n2 = o2[0], t2 = o2[o2.length - 1];
            i && e4.startTime - t2.startTime < 1e3 && e4.startTime - n2.startTime < 5e3 ? (i += e4.value, o2.push(e4)) : (i = e4.value, o2 = [e4]);
          }
        }), i > r.value && (r.value = i, r.entries = o2, t());
      }, u2 = s("layout-shift", c2);
      u2 && (t = d(e2, r, L, n.reportAllChanges), p(function() {
        c2(u2.takeRecords()), t(true);
      }), a(function() {
        i = 0, r = f("CLS", 0), t = d(e2, r, L, n.reportAllChanges), l(function() {
          return t();
        });
      }), setTimeout(t, 0));
    }));
  };
  var A = 0;
  var I = 1 / 0;
  var P = 0;
  var M = function(e2) {
    e2.forEach(function(e3) {
      e3.interactionId && (I = Math.min(I, e3.interactionId), P = Math.max(P, e3.interactionId), A = P ? (P - I) / 7 + 1 : 0);
    });
  };
  var k = function() {
    return e ? A : performance.interactionCount || 0;
  };
  var F = function() {
    "interactionCount" in performance || e || (e = s("event", M, { type: "event", buffered: true, durationThreshold: 0 }));
  };
  var D = [];
  var x = /* @__PURE__ */ new Map();
  var R = 0;
  var B = function() {
    var e2 = Math.min(D.length - 1, Math.floor((k() - R) / 50));
    return D[e2];
  };
  var H = [];
  var q = function(e2) {
    if (H.forEach(function(n2) {
      return n2(e2);
    }), e2.interactionId || "first-input" === e2.entryType) {
      var n = D[D.length - 1], t = x.get(e2.interactionId);
      if (t || D.length < 10 || e2.duration > n.latency) {
        if (t) e2.duration > t.latency ? (t.entries = [e2], t.latency = e2.duration) : e2.duration === t.latency && e2.startTime === t.entries[0].startTime && t.entries.push(e2);
        else {
          var r = { id: e2.interactionId, latency: e2.duration, entries: [e2] };
          x.set(r.id, r), D.push(r);
        }
        D.sort(function(e3, n2) {
          return n2.latency - e3.latency;
        }), D.length > 10 && D.splice(10).forEach(function(e3) {
          return x.delete(e3.id);
        });
      }
    }
  };
  var O = function(e2) {
    var n = self.requestIdleCallback || self.setTimeout, t = -1;
    return e2 = v(e2), "hidden" === document.visibilityState ? e2() : (t = n(e2), p(e2)), t;
  };
  var N = [200, 500];
  var j = function(e2, n) {
    "PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && (n = n || {}, C(function() {
      var t;
      F();
      var r, i = f("INP"), o2 = function(e3) {
        O(function() {
          e3.forEach(q);
          var n2 = B();
          n2 && n2.latency !== i.value && (i.value = n2.latency, i.entries = n2.entries, r());
        });
      }, c2 = s("event", o2, { durationThreshold: null !== (t = n.durationThreshold) && void 0 !== t ? t : 40 });
      r = d(e2, i, N, n.reportAllChanges), c2 && (c2.observe({ type: "first-input", buffered: true }), p(function() {
        o2(c2.takeRecords()), r(true);
      }), a(function() {
        R = k(), D.length = 0, x.clear(), i = f("INP"), r = d(e2, i, N, n.reportAllChanges);
      }));
    }));
  };
  var _ = [2500, 4e3];
  var z = {};
  var G = function(e2, n) {
    n = n || {}, C(function() {
      var t, r = E(), i = f("LCP"), o2 = function(e3) {
        n.reportAllChanges || (e3 = e3.slice(-1)), e3.forEach(function(e4) {
          e4.startTime < r.firstHiddenTime && (i.value = Math.max(e4.startTime - u(), 0), i.entries = [e4], t());
        });
      }, c2 = s("largest-contentful-paint", o2);
      if (c2) {
        t = d(e2, i, _, n.reportAllChanges);
        var m2 = v(function() {
          z[i.id] || (o2(c2.takeRecords()), c2.disconnect(), z[i.id] = true, t(true));
        });
        ["keydown", "click"].forEach(function(e3) {
          addEventListener(e3, function() {
            return O(m2);
          }, { once: true, capture: true });
        }), p(m2), a(function(r2) {
          i = f("LCP"), t = d(e2, i, _, n.reportAllChanges), l(function() {
            i.value = performance.now() - r2.timeStamp, z[i.id] = true, t(true);
          });
        });
      }
    });
  };

  // src/plugins/browser-performance.ts
  var BrowserPerformance = class {
    init(sdk2) {
      if (typeof window === "undefined") return;
      const onLoad = () => {
        const basic = getBasic();
        const resources = getResources();
        if (!isEmpty(basic)) {
          sdk2.report({
            module: "performance",
            action: "performance_basic",
            elapsed: basic.duration,
            logs: basic
          });
        }
        if (!isEmpty(resources)) {
          sdk2.report({
            module: "performance",
            action: "resources",
            elapsed: basic.resource,
            logs: resources
          });
        }
      };
      G((metric) => {
        sdk2.report({
          module: "performance",
          action: "lcp",
          elapsed: formatDecimal(metric.value, 3),
          status: metric.rating,
          logs: metric.entries
        });
      });
      w((metric) => {
        sdk2.report({
          module: "performance",
          action: "cls",
          elapsed: formatDecimal(metric.value, 3),
          status: metric.rating,
          logs: metric.entries
        });
      });
      j((metric) => {
        sdk2.report({
          module: "performance",
          action: "inp",
          elapsed: formatDecimal(metric.value, 3),
          status: metric.rating,
          logs: metric.entries
        });
      });
      if (document.readyState === "complete") {
        setTimeout(onLoad, 0);
      } else {
        window.addEventListener("load", () => {
          setTimeout(onLoad, 0);
        });
      }
    }
  };
  function getBasic() {
    if (typeof performance === "undefined") return {};
    const {
      domainLookupEnd,
      domainLookupStart,
      connectEnd,
      connectStart,
      secureConnectionStart,
      loadEventStart,
      // loadEventEnd,
      domInteractive,
      domContentLoadedEventEnd,
      duration,
      responseStart,
      requestStart,
      responseEnd,
      fetchStart,
      // transferSize,
      // encodedBodySize,
      redirectEnd,
      redirectStart,
      redirectCount
    } = performance.getEntriesByType("navigation")[0];
    const { startTime: fp } = performance.getEntriesByType("paint").find(({ name }) => name === "first-paint") || {};
    const { startTime: fcp } = performance.getEntriesByType("paint").find(({ name }) => name === "first-contentful-paint") || {};
    return {
      dns: formatDecimal(domainLookupEnd - domainLookupStart, 3),
      tcp: formatDecimal(connectEnd - connectStart, 3),
      ssl: formatDecimal(connectEnd - secureConnectionStart, 3),
      request: formatDecimal(responseStart - requestStart, 3),
      response: formatDecimal(responseEnd - responseStart, 3),
      domParse: formatDecimal(domInteractive - responseEnd, 3),
      resource: formatDecimal(loadEventStart - domContentLoadedEventEnd, 3),
      domReady: formatDecimal(domContentLoadedEventEnd - fetchStart, 3),
      interactive: formatDecimal(domInteractive - fetchStart, 3),
      complete: formatDecimal(loadEventStart - fetchStart, 3),
      // httpHead: formatDecimal(encodedBodySize - transferSize, 3),
      redirect: formatDecimal(redirectCount, 3),
      redirectTime: formatDecimal(redirectEnd - redirectStart, 3),
      duration: formatDecimal(duration, 3),
      fp: formatDecimal(Number(fp), 3),
      fcp: formatDecimal(Number(fcp), 3)
    };
  }
  function getResources() {
    if (typeof performance === "undefined") return [];
    const resources = performance.getEntriesByType("resource");
    return resources.map((value) => ({
      name: value.name,
      duration: formatDecimal(value.duration, 3)
    }));
  }

  // src/plugins/browser-request.ts
  var BrowserRequest = class {
    constructor(options) {
      this.options = options || {};
    }
    init(sdk2) {
      if (typeof window === "undefined") return;
      this.overwriteXHR(sdk2);
      this.overwriteFetch(sdk2);
    }
    overwriteXHR(sdk2) {
      const originalOpen = XMLHttpRequest.prototype.open;
      const originalSend = XMLHttpRequest.prototype.send;
      const exclude = this.options.exclude || [];
      XMLHttpRequest.prototype.open = function(_method, url) {
        this._url = url;
        return originalOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function(_body) {
        const startTime = Date.now();
        const url = this._url;
        if (!url || url.indexOf("/monitorApi/") > -1 || exclude.some((pattern) => url.includes(pattern))) {
          return originalSend.apply(this, arguments);
        }
        const getSimpleTraceId = () => {
          if (url.indexOf("/sea_shell/") === -1) return "";
          return this.getResponseHeader("Simple-Traceid") || "";
        };
        const onReadyStateChange = (_event) => {
          if (this.readyState === XMLHttpRequest.DONE) {
            const duration = Date.now() - startTime;
            const status = this.status;
            const ok = status >= 200 && status < 300;
            sdk2.report({
              module: "request",
              action: ok ? "xhr" : "xhr_error",
              status: String(status),
              target: url,
              elapsed: duration,
              logs: { ["Simple-Traceid"]: getSimpleTraceId(), statusText: this.statusText }
            });
          }
        };
        const onError = (_event) => {
          sdk2.report({
            module: "request",
            action: "xhr_error",
            status: String(this.status),
            target: this._url,
            logs: { ["Simple-Traceid"]: getSimpleTraceId(), statusText: this.statusText }
          });
        };
        this.addEventListener("readystatechange", onReadyStateChange);
        this.addEventListener("error", onError);
        return originalSend.apply(this, arguments);
      };
    }
    overwriteFetch(sdk2) {
      const originalFetch = window.fetch;
      const exclude = this.options.exclude || [];
      window.fetch = function(...args) {
        const [resource, _config] = args;
        const startTime = Date.now();
        if (typeof resource === "string" && (resource.indexOf("/monitorApi/") > -1 || exclude.some((pattern) => resource.includes(pattern)))) {
          return originalFetch.apply(this, args);
        }
        return originalFetch.apply(this, args).then((response) => {
          const duration = Date.now() - startTime;
          const status = response.status;
          const headers = response.headers;
          let simpleTraceId = "";
          if (typeof resource === "string" && resource.indexOf("/sea_shell/") > -1) {
            simpleTraceId = headers.get("Simple-Traceid") || "";
          }
          sdk2.report({
            module: "request",
            action: response.ok ? "fetch" : "fetch_error",
            status: String(status),
            target: resource.toString(),
            elapsed: duration,
            logs: { ["Simple-Traceid"]: simpleTraceId, statusText: response.statusText }
          });
          return response;
        }).catch((error) => {
          const duration = Date.now() - startTime;
          const stk = parseStackFrames(error, 10);
          sdk2.report({
            module: "request",
            action: "fetch_error",
            status: "catch",
            target: resource.toString(),
            elapsed: duration,
            logs: stk
          });
          const count = (error.__monitor_stk_count__ || 0) + 1;
          error.__monitor_stk_count__ = count;
          throw error;
        });
      };
    }
  };

  // src/browser.ts
  var defaultConfig = {
    endpoint: "https://app.hopegoo.com/monitorApi/useBehaviorLog/postData",
    app: "",
    version: "",
    enable: true
  };
  var sdk;
  function init(_config = {}) {
    if (typeof window === "undefined") return;
    const config = Object.assign({}, defaultConfig, _config);
    if (!config.app) {
      throw new Error("app name is required");
    }
    if (!config.version) {
      throw new Error("app version is required");
    }
    if (_config.enable === void 0) {
      if (isIPAddress(window.location.hostname) || window.location.hostname === "localhost") {
        config.enable = false;
      }
    }
    sdk = new MonitorSdk2(config);
    sdk.use(new BrowserBase());
    sdk.use(new BrowserBase2());
    sdk.use(new BrowserPerformance());
    sdk.use(new BrowserRequest({ exclude: ["/seaManatee/"] }));
  }
  function use(plugin) {
    if (sdk) {
      sdk.use(plugin);
    }
  }
  if (typeof SonarConfig == "object") {
    init(SonarConfig);
  }
  return __toCommonJS(browser_exports);
})();
